import "src/config/dayjsConfig.ts";
import {Duration} from "dayjs/plugin/duration";

export function separateDuration(duration: Duration): { days: number; hours: number; minutes: number } {
	const fullDays = Math.floor(duration.asDays());
	const fullHours = Math.floor(duration.subtract({ days: fullDays }).asHours());
	const fullMinutes = Math.floor(duration.subtract({ days: fullDays, hours: fullHours }).asMinutes());
	return { days: fullDays, hours: fullHours, minutes: fullMinutes };
}
